import React from "react";
import { CardActionOption } from "../../components/cardActionOption";
import { useClient } from "../../hooks/client";

import {
  Container,
  Content,
  OptionsWrapper,
  SentIcon,
  VilapayIcon,
  Text,
} from "./styles";

export const Transfer: React.FC = () => {
  const {client} = useClient();
  // const [SidebarMobileIsActive, setSidebarMobileIsActive] = useState(false);

  // const handleSidebarMobileToggle = () => {
  //   setSidebarMobileIsActive((state) => !state);
  // };

  return (
    <Container>
      <Content>
        <OptionsWrapper>
          <CardActionOption
            Icon={VilapayIcon}
            linkTo="list"
            title={`Entre contas ${client.name}`}
          />
          <CardActionOption
            Icon={SentIcon}
            linkTo="subscribe"
            title={"Transferir via Pix"}
          />
        </OptionsWrapper>
        <Text>
            <span>
              {/* Transferências solicitadas para outros bancos são processadas em
              até 1 hora. */}
            </span>
          </Text>
      </Content>
    </Container>
  );
};
